/**
 * Utility functions for patient-related operations
 */

/**
 * Formats a patient's name with optional preferred name in quotes
 * @param firstName - Patient's first name
 * @param lastName - Patient's last name
 * @param preferredName - Patient's preferred name (optional)
 * @returns Formatted name string (e.g., "John Smith" or 'John "Johnny" Smith')
 */
export const formatPatientName = (
  firstName?: string | null,
  lastName?: string | null,
  preferredName?: string | null
): string => {
  const first = firstName || '';
  const last = lastName || '';
  const preferred = preferredName || '';

  if (preferred) {
    return `${first} "${preferred}" ${last}`.trim();
  }
  return `${first} ${last}`.trim();
};